import ReportEditor from "./ReportEditor";

function ReportEditPage() {
  return <ReportEditor />;
}
export default ReportEditPage;
